import {setInitialState} from '../../../utils/reducerOperations';

export const Default=()=>({
    fetchSnapshotApi:setInitialState(),
    pivotApi:setInitialState(),
});